import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';

@Component({
	templateUrl: './settlement-detail.html',
	styleUrls: ['./settlement-detail.component.scss'],
	selector: 'app-settlement-detail'
})
export class SettlementDetailComponent implements OnInit, OnDestroy, OnChanges {
	public dateToDisplay: any;
	public displayedColumns: string[] = ['item', 'settlement'];
	@Input() public settlementDetail;
	public user: User;
	public userSubscription: any;

	constructor(private _userService: UserService) {
	}

    buildDisplayColumns() {
        let cols = ['item'];
        if (this.user.showPrice) {
            cols.push('price');
        }
        if (this.user.showBaseAmount) {
            cols.push('base');
        }
        if (this.user.showDriverSplit) {
            cols.push('driverSplit');
        }
        if (this.user.showPercentOrder) {
            cols.push('driverPercent');
        }
        cols.push('settlement');
        this.displayedColumns = cols;
    }

	ngOnChanges(changes: SimpleChanges): void {
		if (this.settlementDetail.dateTotals) {
			this.dateToDisplay = this.settlementDetail.dateTotals[0].dueTimeTo.formattedDate;
		}
	}

	ngOnDestroy(): void {
		this.userSubscription?.unsubscribe();
	}

	ngOnInit(): void {
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
            this.buildDisplayColumns();
		});
	}

	setDateToDisplay(date) {
		this.dateToDisplay = date;
	}

	/**
	 * Determines if a settlement detail should display as a route card.
	 * Route cards show route-specific fields and ignore user visibility settings.
	 * 
	 * Field Mappings for Route Cards:
	 * - displayId → Route ID (e.g., "Christy.Route")
	 * - settlementDetailItems[0].baseAmount → Route Pay
	 * - surchargeSettlement → Surcharge Pay
	 * - Calculated: baseAmount + surchargeSettlement → Total
	 * 
	 * Note: Route cards are ALWAYS visible regardless of user.showBaseAmount setting.
	 */
	isRouteCard(detail: any): boolean {
		return detail?.isRoute === true;
	}

	/**
	 * Calculates the total pay for a route settlement.
	 * Total = Route Pay (first settlementDetailItem baseAmount) + Surcharge Pay
	 * 
	 * Uses optional chaining and null coalescing for safe data access.
	 */
	calculateRouteTotal(detail: any): number {
		const routePay = detail?.settlementDetailItems?.[0]?.baseAmount ?? 0;
		const surchargePay = detail?.surchargeSettlement ?? 0;
		return routePay + surchargePay;
	}
}
